import { render, staticRenderFns } from "./SerasaPJ.vue?vue&type=template&id=039c7706"
import script from "./SerasaPJ.vue?vue&type=script&lang=js"
export * from "./SerasaPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports